import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import FormProgress from '../../../features/components/Form/FormProgress'

import drawerFormStyles from '../../../styles/common/drawerForms'

function DrawerHeadline({ formProgressItems, title, description }) {
  const { t } = useTranslation()

  const classes = drawerFormStyles()

  // there are places which requires to send JSX element instead of just string
  const translatedTitle = typeof title === 'string' ? t(title) : title

  if (title) {
    return (
      <>
        {formProgressItems && <FormProgress items={formProgressItems} />}
        <h2 className={classes.formTitle}>{translatedTitle}</h2>
        {description && <p>{description}</p>}
      </>
    )
  }

  return null
}

DrawerHeadline.propTypes = {
  formProgressItems: PropTypes.array,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
}

export default DrawerHeadline
